import DocsPage from "@/features/docs/docs.page";
import { validateDocSearch } from "@/features/docs/utils/doc-search";
import { IncognitoDocumentPage } from "@/features/superuser/incognito/project/incognito-document.page";
import { useWorkspaceAccess } from "@/features/workspaces/use-workspace-access";
import { ProjectRoute } from "@/routes/_authenticated/workspaces/$slug/projects/$projectSlug";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/workspaces/$slug/projects/$projectSlug/docs/$docId",
)({
  validateSearch: validateDocSearch,
  component: DocPageRoute,
});

// CR-165: incognito mode gets the read-only snapshot page (no collab provider,
// no presence, no comments, no versions modal); the member page is untouched.
function DocPageRoute() {
  const workspaceAccess = useWorkspaceAccess();
  const { project } = ProjectRoute.useRouteContext();
  const { docId } = Route.useParams();

  if (workspaceAccess.mode === "incognito") {
    return <IncognitoDocumentPage key={docId} project={project} documentId={docId} />;
  }

  return <DocsPage />;
}
